var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('factom'),
    Entry = _require.Entry,
    isValidEcAddress = _require.isValidEcAddress;

var _require2 = require('../crypto'),
    sha256d = _require2.sha256d,
    secretToPublicKey = _require2.secretToPublicKey;

var _require3 = require('./common'),
    extractSecretFromIdentityKey = _require3.extractSecretFromIdentityKey,
    sign = _require3.sign;

var _require4 = require('./identity-chains'),
    getIdentityRootChain = _require4.getIdentityRootChain;

var _require5 = require('./validation'),
    isValidSk1 = _require5.isValidSk1,
    isValidServerIdentityChainId = _require5.isValidServerIdentityChainId;

function add(_x, _x2, _x3, _x4, _x5, _x6) {
  return _add.apply(this, arguments);
}
/**
 * @memberof server
 * @param {string} rootChainId - Identity Root Chain Id.
 * @param {string} serverManagementSubchainId - Server Management Subchain Id.
 * @param {number} height - Block height of the coinbase descriptor to cancel.
 * @param {number} index - Index of the coinbase descriptor to cancel.
 * @param {string} sk1 - Server identity Secret Key 1.
 * @returns {{{chainId: Buffer, extIds: Buffer[], content: Buffer}}}
 */


function _add() {
  _add = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(cli, rootChainId, height, index, sk1, ecAddress) {
    var balance, rootChain, identityKey, entry;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isValidEcAddress(ecAddress)) {
              _context.next = 2;
              break;
            }

            throw new Error("Invalid EC address ".concat(ecAddress));

          case 2:
            if (isValidSk1(sk1)) {
              _context.next = 4;
              break;
            }

            throw new Error('Lowest level identity key (sk1) is not valid');

          case 4:
            _context.next = 6;
            return cli.getBalance(ecAddress);

          case 6:
            balance = _context.sent;

            if (!(balance < 1)) {
              _context.next = 9;
              break;
            }

            throw new Error('Insufficient EC balance to pay for adding coinbase cancel entry');

          case 9:
            _context.next = 11;
            return getIdentityRootChain(cli, rootChainId);

          case 11:
            rootChain = _context.sent;
            identityKey = sha256d(Buffer.concat([Buffer.from('01', 'hex'), secretToPublicKey(extractSecretFromIdentityKey(sk1))]));

            if (rootChain.identityKeys[0].equals(identityKey)) {
              _context.next = 15;
              break;
            }

            throw new Error("The SK1 key cannot sign in the Identity Root Chain ".concat(rootChainId));

          case 15:
            entry = Entry.builder(generateCoinbaseCancelEntry(rootChainId, rootChain.serverManagementSubchainId.toString('hex'), height, index, sk1)).build();
            _context.next = 18;
            return cli.add(entry, ecAddress);

          case 18:
            return _context.abrupt("return", _context.sent);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _add.apply(this, arguments);
}

function generateCoinbaseCancelEntry(rootChainId, serverManagementSubchainId, height, index, sk1) {
  if (!isValidServerIdentityChainId(rootChainId)) {
    throw new Error("Invalid root chain id ".concat(rootChainId));
  }

  if (!isValidServerIdentityChainId(serverManagementSubchainId)) {
    throw new Error("Invalid server management subchain id ".concat(serverManagementSubchainId));
  }

  if (rootChainId === serverManagementSubchainId) {
    throw new Error("The root chain id cannot be the same as the server management subchain id (".concat(rootChainId, ")"));
  }

  if (!isValidSk1(sk1)) {
    throw new Error('Lowest level identity key (sk1) is not valid');
  }

  if (typeof height !== 'number' || index < 0) {
    throw new Error('Descriptor height should be a positive number');
  }

  if (typeof index !== 'number' || index < 0) {
    throw new Error('Descriptor index should be a positive number');
  }

  var version = Buffer.from('00', 'hex');
  var marker = Buffer.from('Coinbase Cancel', 'utf8');
  var chainId = Buffer.from(rootChainId, 'hex');
  var descriptorHeight = Buffer.allocUnsafe(4);
  descriptorHeight.writeUInt32BE(height);
  var descriptorIndex = Buffer.allocUnsafe(4);
  descriptorIndex.writeUInt32BE(index);
  var dataToSign = Buffer.concat([version, marker, chainId, descriptorHeight, descriptorIndex]);

  var _sign = sign(extractSecretFromIdentityKey(sk1), dataToSign),
      identityKeyPreImage = _sign.identityKeyPreImage,
      signature = _sign.signature;

  return {
    chainId: Buffer.from(serverManagementSubchainId, 'hex'),
    extIds: [version, marker, chainId, descriptorHeight, descriptorIndex, identityKeyPreImage, signature],
    content: Buffer.from('')
  };
}

module.exports = {
  add: add,
  generateCoinbaseCancelEntry: generateCoinbaseCancelEntry
};